import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LikeBtn = _resolveComponent("LikeBtn")!

  return (_ctx.showLikeBtn)
    ? (_openBlock(), _createBlock(_component_LikeBtn, {
        key: 0,
        linkTotalNum: _ctx.linkTotalNum,
        isLike: _ctx.isLike,
        isShowAnimate: _ctx.isShowAnimate,
        likeType: "playData",
        onLike: _ctx.like,
        onCancelLike: _ctx.cancelLike
      }, null, 8, ["linkTotalNum", "isLike", "isShowAnimate", "onLike", "onCancelLike"]))
    : _createCommentVNode("", true)
}